import React from 'react';
import { useLoadersTracingRef } from 'monitoring/use-loaders-tracing-ref';

import { bemBlock } from '@neptune/shared/venus-ui';

import './SkeletonLoader.less';

const block = bemBlock('skeleton-loader');

type SkeletonLoaderProps = {
  className?: string;
};

export const SkeletonLoader = ({ className }: SkeletonLoaderProps) => {
  const loaderRef = useLoadersTracingRef<HTMLDivElement>(true);

  return (
    <div ref={loaderRef} data-role="skeleton-loader" className={block({ extra: className })}>
      &nbsp;
    </div>
  );
};
